const docLang = document.documentElement.lang;
export const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
export const labels = {
  prev: {
    de: 'Zum vorherigen Bild springen',
    en: 'move to previous image',
  },
  next: {
    de: 'Zum nächsten Bild springen',
    en: 'move to next image',
  },
  close: {
    de: 'Lightbox Schließen (Esc)',
    en: 'Close lightbox (Esc)',
  },
  zoom: {
    de: 'Bild vergrößern/verkleinern',
    en: 'Zoom image in/out',
  },
  download: {
    de: 'Bild herunterladen',
    en: 'Download Image',
  },
};

const template = `
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="pswp__bg"></div>
  <div class="pswp__scroll-wrap">
    <div class="pswp__container">
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
    </div>
    <div class="pswp__ui pswp__ui--hidden">
      <div class="pswp__top-bar">

        <div class="pswp_imagetitle_text">
          <p id="pswp_imagetitle" class="is-xlarge"></p>
        </div>
        <div class="pswp__buttons">
          <button class="btn pswp__button pswp__button--close" title="${labels.close[lang]}">
            <svg  class="svg-close" aria-hidden="true" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <g stroke="none" stroke-width="1" fill-rule="evenodd">
                <polygon fill="none" points="0 0 24 0 24 24 0 24"></polygon>
                <polygon fill="currentColor" fill-rule="nonzero" transform="translate(11.939340, 12.060660) rotate(135.000000) translate(-11.939340, -12.060660) " points="1.43933983 11.0606602 22.4393398 11.0606602 22.4393398 13.0606602 1.43933983 13.0606602"></polygon>
                <polygon fill="currentColor" fill-rule="nonzero" transform="translate(12.060660, 12.060660) rotate(45.000000) translate(-12.060660, -12.060660) " points="1.56066017 11.0606602 22.5606602 11.0606602 22.5606602 13.0606602 1.56066017 13.0606602"></polygon>
              </g>
            </svg>
            <span class="sr-only">${labels.close[lang]}</span>
          </button>
          <button class="btn pswp__button pswp__button--zoom" title="${labels.zoom[lang]}">
            <svg class="svg-zoom-in" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" width="21" height="21">
              <path fill="currentColor" d="m18 16.6 4.3 4.3-1.4 1.4-4.3-4.3C15 19.3 13 20 11 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9c0 2-.7 4-2 5.6zm-2-.7c1.3-1.3 2-3.1 2-4.9 0-3.9-3.1-7-7-7s-7 3.1-7 7 3.1 7 7 7c1.8 0 3.6-.7 4.9-2l.1-.1zM10 10V7h2v3h3v2h-3v3h-2v-3H7v-2h3z" transform="translate(-2 -2)"/>
            </svg>
            <svg class="svg-zoom-out" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 21 21" width="21" height="21">
              <path fill="currentColor" d="m16 14.6 4.3 4.3-1.4 1.4-4.3-4.3C13 17.3 11 18 9 18c-5 0-9-4-9-9s4-9 9-9 9 4 9 9c0 2-.7 4-2 5.6zm-2-.7c1.3-1.3 2-3.1 2-4.9 0-3.9-3.1-7-7-7S2 5.1 2 9s3.1 7 7 7c1.8 0 3.6-.7 4.9-2l.1-.1zM13 8v2H5V8h8z"/>
            </svg>
            <span class="sr-only">${labels.zoom[lang]}</span>
          </button>
        </div>
        <div class="pswp__preloader">
          <div class="pswp__preloader__icn">
            <div class="pswp__preloader__cut">
              <div class="pswp__preloader__donut"></div>
            </div>
          </div>
        </div>
      </div>
      <button class="pswp__button pswp__button--arrow--left" title="${labels.prev[lang]}">
        <span class="sr-only">${labels.prev[lang]}</span>
        <svg class="svg-chevron-left" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14">
          <polygon fill="currentColor" transform="translate(-8.000000, -5.000000)" points="10.828 12 15.778 16.95 14.364 18.364 8 12 14.364 5.636 15.778 7.05"></polygon>
        </svg>
      </button>
      <button class="pswp__button pswp__button--arrow--right" title="${labels.next[lang]}">
        <span class="sr-only">${labels.next[lang]}</span>
          <svg class="svg-chevron-right" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14">
            <polygon fill="currentColor" transform="translate(-8.000000, -5.000000)" points="13.172 12 8.222 7.05 9.636 5.636 16 12 9.636 18.364 8.222 16.95"></polygon>
          </svg>
      </button>
      <div class="pswp__caption">
        <div class="pswp__caption-inner is-xsmall">
        </div>
      </div>
      <div class="pswp__counter is-small"></div>
    </div>
  </div>
</div>
`;

export default template;
